import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import { modalActionBody } from 'components/common/Elements/NewModal/newModal';

export const getRestartOptions = (
  isGW,
  setAction,
  role,
  actionName,
  title,
  startAction,
  isCpuResizeEnabled
) => {
  const { t } = useTranslation(['activity']);
  const dropdown = isGW
    ? [
        {
          label: t('activity:cm.ACTION-SOFT-RESTART'),
          handleClick: () => {
            setAction({
              actionName: t('activity:cm.ACTION-SOFT-RESTART'),
              actionKey: 'soft-restart'
            });
            modalActionBody({
              title: t('activity:cm.ACTION-SOFT-RESTART'),
              callBack: () =>
                startAction({ actionName, actionKey: 'soft-restart' }),
              text: t('activity:modalText.NETWORK_ACTION_CONFIRM', {
                actionName: t('activity:cm.ACTION-SOFT-RESTART'),
                text: title
              })
            });
          }
        },
        {
          label: t('activity:cm.ACTION-HARD-RESTART'),
          handleClick: () => {
            setAction({
              actionName: t('activity:cm.ACTION-HARD-RESTART'),
              actionKey: 'hard-restart'
            });
            modalActionBody({
              title: t('activity:cm.ACTION-HARD-RESTART'),
              callBack: () =>
                startAction({ actionName, actionKey: 'hard-restart' }),
              text: t('activity:modalText.NETWORK_ACTION_CONFIRM', {
                actionName: t('activity:cm.ACTION-HARD-RESTART'),
                text: title
              })
            });
          }
        },
        {
          label: t('activity:cm.ACTION-GATEWAY-REBUILD'),
          handleClick: () => {
            setAction({
              actionName: t('activity:cm.ACTION-GATEWAY-REBUILD'),
              actionKey: 'gateway-rebuild'
            });

            modalActionBody({
              title: t('activity:cm.ACTION-GATEWAY-REBUILD'),
              callBack: () =>
                startAction({
                  actionName,
                  actionKey: 'gateway-rebuild'
                }),
              text: t('activity:modalText.NETWORK_ACTION_CONFIRM', {
                actionName: t('activity:cm.ACTION-GATEWAY-REBUILD'),
                text: title
              })
            });
          }
        },
        {
          label: t('activity:cm.ACTION-GATEWAY-UPGRADE'),
          handleClick: () => {
            const act = {
              actionName: t('activity:cm.ACTION-GATEWAY-UPGRADE'),
              actionKey: 'force-gateway-upgrade',
              requiresVersion: true
            };
            setAction(act);
            startAction(act);
          }
        }
      ]
    : [
        {
          label: t('activity:cm.ACTION-TUNNEL-RESTART'),
          handleClick: () => {
            setAction({
              actionName: t('activity:cm.ACTION-TUNNEL-RESTART'),
              actionKey: 'tunnel-restart'
            });

            modalActionBody({
              title: t('activity:cm.ACTION-TUNNEL-RESTART'),
              callBack: () =>
                startAction({
                  actionName,
                  actionKey: 'tunnel-restart'
                }),
              text: t('activity:modalText.NETWORK_ACTION_CONFIRM', {
                actionName: t('activity:cm.ACTION-TUNNEL-RESTART'),
                text: title
              })
            });
          }
        }
      ];
  isGW &&
    isCpuResizeEnabled &&
    dropdown.push({
      label: t('activity:cm.ACTION-GW-CPU-RESIZE'),
      handleClick: () => {
        // The size selector needs a value back from the user, so it goes
        // through startAction's deferred-modal path rather than a confirm.
        const act = {
          actionName: t('activity:cm.ACTION-GW-CPU-RESIZE'),
          actionKey: 'cpu-resize',
          requiresSize: true
        };
        setAction(act);
        startAction(act);
      }
    });
  return dropdown;
};
export const getRequestBody = (isGW, netComponent, customerId, action) => {
  const REQ_BODY = { customerId: customerId };
  Object.assign(
    REQ_BODY,
    isGW
      ? { gatewayId: netComponent.gatewayId }
      : { tunnelId: netComponent.tunnelId }
  );
  if (!isEmpty(action)) {
    Object.assign(REQ_BODY, { action: action.actionKey });
    if (action.version) {
      REQ_BODY.version = action.version;
    }
    if (action.instancePlanType) {
      REQ_BODY.instancePlanType = action.instancePlanType;
    }
  }
  return REQ_BODY;
};
